/**
 * A PÍLULA CHATA de filtro — a fonte única do estilo usado pelos botões de
 * recorte das listas (status em `/quotes`, contato em `/clients`, categoria em
 * `/catalog`) e pelos grupos dos modais de filtro.
 *
 * Ela nasceu dentro do `QuoteFiltersDialog` e subiu para cá quando a segunda
 * lista adotou o desenho: com a constante morando num diálogo, a terceira tela
 * ou importaria de um componente que ela não usa, ou (o que sempre acontece)
 * copiaria as classes e divergiria na primeira mudança — que é exatamente o
 * defeito que o #25 descreve para os alternadores de aba.
 *
 * NÃO é o estilo de alternador de ABA: recorte não pode parecer troca de
 * contexto, e por isso aqui não há a pílula 3D azul do `<Tabs>` (#25/#188).
 */

export const FILTER_CHIP =
  'rounded-full border px-3 py-1.5 text-sm font-medium transition-colors disabled:opacity-50';
export const FILTER_CHIP_ON = 'border-primary bg-primary/10 text-primary';
export const FILTER_CHIP_OFF = 'border-border/60 bg-card text-muted-foreground hover:bg-muted';

/**
 * A versão COMPACTA, usada na faixa de recorte que fica na própria tela.
 *
 * O tamanho não é gosto: em 360px sobram 328 úteis e os cinco rótulos de status
 * só couberam em uma linha com `text-[11px]` + `px-1.5` (medido em #191 — a
 * escada inteira está lá). `whitespace-nowrap` + `shrink-0` são o que impedem o
 * flex de "resolver" o excesso encolhendo os itens, que truncaria o rótulo.
 */
export const FILTER_CHIP_COMPACT =
  'shrink-0 whitespace-nowrap rounded-full border px-1.5 py-0.5 text-[11px] font-medium leading-5 transition-colors';

/**
 * A faixa que embrulha os chips compactos.
 *
 * `overflow-x-auto` é REDE DE SEGURANÇA, não o desenho: com os rótulos cabendo
 * ele nunca rola. Ele existe porque a folga é de poucos pixels e uma métrica de
 * fonte diferente empurraria o último botão para FORA da viewport — que é o
 * #185, e é um estrago maior do que uma barra que rola. Em `/catalog` os
 * rótulos são as CATEGORIAS do usuário (texto livre, quantidade desconhecida),
 * então ali ele rola de verdade — e é por isso que ele precisa existir.
 */
export const FILTER_CHIP_ROW = '-mx-1 flex gap-1 overflow-x-auto px-1 pb-0.5';
